import React from 'react';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout({ children }) {
  return (
    <div className="flex h-[calc(100vh-var(--preprod-banner-height,0px))] bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <AdminSidebar />
      
      {/* Main content — min-h-0 permet au main de défiler seul (sinon min-height:auto étire la colonne = double scroll + vide en bas) */}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <main className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          {children}
        </main>
      </div>
    </div>
  );
}
